module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex flex-col static space-y-2 w-full h-full mb-16 px-5"
  }, [_c('div', {
    staticClass: "flex items-center justify-between py-2"
  }, [_vm._m(0), _vm._v(" "), (_vm.genieRecap && _vm.hasTeacherPermissionsInCourse) ? _c('button', {
    staticClass: "w-7 h-7 bg-blueGray-50 border border-solid hover:bg-blueGray-100 text-blueGray-600 hover:text-blueGray-700 border-blueGray-600 rounded-full",
    attrs: {
      "title": "Refresh"
    },
    on: {
      "click": function($event) {
        return _vm.handleRefreshRecap()
      }
    }
  }, [_c('i', {
    staticClass: "fa-solid text-sm fa-rotate",
    class: _vm.isGenerating === true ? 'animate-spin' : ''
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "h-full flex flex-col flex-grow"
  }, [(_vm.genieRecap !== null) ? _c('div', {
    staticClass: "flex flex-col"
  }, [_c('div', [_c('div', {
    staticClass: "font-poppins text-gray-700 font-normal",
    domProps: {
      "innerHTML": _vm._s(_vm.genieRecap.prompt_summary)
    }
  })]), _vm._v(" "), (_vm.hasTeacherPermissionsInCourse) ? _c('div', {
    staticClass: "flex flex-col space-y-4 mb-6"
  }, [_vm._m(1), _vm._v(" "), _vm._l((_vm.genieRecap.questions), function(q, index) {
    return _c('div', {
      key: index,
      staticClass: "mb-3"
    }, [_c('span', [_c('span', {
      staticClass: "font-poppins text-gray-700 font-semibold"
    }, [_vm._v(_vm._s(index + 1) + ".")]), _vm._v(" "), _c('span', {
      staticClass: "font-normal text-gray-700 font-poppins"
    }, [_vm._v(_vm._s(q.question))])])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.hasTeacherPermissionsInCourse) ? _c('div', {
    staticClass: "flex flex-col space-y-4"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col space-y-2.5"
  }, [_c('button', {
    staticClass: "sample px-5 py-3.5 border hover:border-gray-300 border-gray-200 hover:bg-gray-50 text-left border-solid rounded cursor-pointer disabled:opacity-60",
    on: {
      "click": function($event) {
        return _vm.handleOpenCurrentFollowUpOption()
      }
    }
  }, [_vm._m(3)]), _vm._v(" "), _c('button', {
    staticClass: "px-5 py-3.5 border hover:border-gray-300 text-left hover:bg-gray-50 border-gray-200 border-solid rounded cursor-pointer disabled:opacity-60",
    on: {
      "click": function($event) {
        return _vm.handleStartFollowUp('written')
      }
    }
  }, [_vm._m(4)]), _vm._v(" "), _c('button', {
    staticClass: "px-5 py-3.5 border hover:border-gray-300 hover:bg-gray-50 border-solid text-left border-gray-200 rounded cursor-pointer disabled:opacity-60",
    on: {
      "click": function($event) {
        return _vm.handleStartFollowUp('verbal')
      }
    }
  }, [_vm._m(5)])])]) : _vm._e()]) : (_vm.hasTeacherPermissionsInCourse && _vm.genieRecap === null) ? _c('div', {
    staticClass: "flex flex-col space-y-4"
  }, [_c('span', {
    staticClass: "font-poppins font-light text-gray-800"
  }, [_vm._v("\n        Ask the Genie to summarize turn by turn from all discussion and generate follow up questions!\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "px-4 py-2 bg-pink-50 border border-solid border-pinky rounded-md text-pinky font-semibold hover:bg-pink-100",
    on: {
      "click": function($event) {
        return _vm.handleCreateGenieRecap()
      }
    }
  }, [_vm._v("\n        Generate\n      ")])]) : _vm._e()]), _vm._v(" "), _vm._m(6)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center space-x-3"
  }, [_c('img', {
    staticClass: "avatar w-8 h-8 rounded-full",
    attrs: {
      "src": "/static/roundtable_options_create/genie_icon.svg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "font-semibold font-poppins text-gray-800 text-base"
  }, [_vm._v(" Genie Recap ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center space-x-3 text-base text-pinky"
  }, [_c('i', {
    staticClass: "fa-solid fa-thumbtack"
  }), _vm._v(" "), _c('h5', {
    staticClass: "font-poppins font-semibold"
  }, [_vm._v("Follow Up Questions")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center space-x-3 text-base text-gray-700"
  }, [_c('i', {
    staticClass: "fa-solid fa-share text-gray-700 text-base"
  }), _vm._v(" "), _c('h5', {
    staticClass: "font-poppins font-semibold"
  }, [_vm._v("Share Follow Up Questions")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center space-x-4"
  }, [_c('img', {
    staticClass: "w-8 h-8",
    attrs: {
      "src": "/static/roundtable_options_create/current_roundtable_icon.svg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col"
  }, [_c('h6', {
    staticClass: "font-medium text-gray-700"
  }, [_vm._v("Current RoundTable")]), _vm._v(" "), _c('span', {
    staticClass: "text-xs text-gray-400 font-poppins font-light"
  }, [_vm._v("\n                  Students can comment one the Genie Recap thread\n                ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center space-x-4"
  }, [_c('div', {
    staticClass: "flex items-center justify-center rounded-full h-8 w-8 bg-blue"
  }, [_c('img', {
    staticClass: "w-4 h-4",
    attrs: {
      "src": "/static/roundtable_icons/written_icon.svg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col"
  }, [_c('h6', {
    staticClass: "font-medium text-gray-700"
  }, [_vm._v("Written RoundTable")]), _vm._v(" "), _c('span', {
    staticClass: "text-xs text-gray-400 font-poppins font-light"
  }, [_vm._v("\n                  Create a new Written RoundTable for the class\n                ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center space-x-4"
  }, [_c('div', {
    staticClass: "flex items-center justify-center rounded-full h-8 w-8 bg-green-light"
  }, [_c('img', {
    staticClass: "w-4 h-4",
    attrs: {
      "src": "/static/roundtable_icons/verbal_icon.svg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col"
  }, [_c('h6', {
    staticClass: "font-medium text-gray-700"
  }, [_vm._v("Verbal RoundTable")]), _vm._v(" "), _c('span', {
    staticClass: "text-xs text-gray-400 font-poppins font-light"
  }, [_vm._v("\n                  Create a new Verbal RoundTable for the class\n                ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex justify-start text-blueGray-800 py-3 text-xs font-poppins font-light"
  }, [_c('span', [_vm._v("Powered by Parlay Genie")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-5b9cf291!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/liveDiscussion/Modals/GenieRecapVerbal.vue
// module id = 1895
// module chunks = 61